<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="CreateBillingPlan"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :resourceTitle="'Billing Plan'|pgettext('CreateBillingPlan|ResourceTitle')"
    :resourceKey="'Collect items'|pgettext('CreateBillingPlan|ResourceKey')"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :name="formName"
    >
      <ItpFormGroup
        name="day"
        labelColsMd="3"
        contentColsMd="4"
        :labelAlign="labelAlign"
        required
        :label="'Target date'|pgettext('CreateBillingPlan')"
        :helpTooltip="'The date from which the system looks for billable items.'|pgettext('CreateBillingPlan')"
      >
        <ItpFormDatetime
          name="day"
          v-model="item.day"
          required
        >
        </ItpFormDatetime>
      </ItpFormGroup>
      <ItpFormGroup
        name="max_date"
        labelColsMd="3"
        contentColsMd="4"
        :labelAlign="labelAlign"
        :label="'Max date'|pgettext('CreateBillingPlan')"
        :helpTooltip="'If no closing date is provided, items due within ten days of the specified date will be collected.'|pgettext('CreateBillingPlan')"
      >
        <ItpFormDatetime
          name="max_date"
          v-model="item.max_date"
        >
        </ItpFormDatetime>
      </ItpFormGroup>
      <ItpFormGroup
        name="contracts"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
        :label="'Contracts'|pgettext('CreateBillingPlan')"
        :helpTooltip="'Search for the selected contract\'s billable services.'|pgettext('CreateBillingPlan')"
      >
        <UcContractSelector
          name="contracts"
          :item="item"
          path="contracts"
          multiple
          clearable
        >
        </UcContractSelector>
      </ItpFormGroup>
      <ItpFormGroup
        name="companies"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
        :label="'Companies'|pgettext('CreateBillingPlan')"
        :helpTooltip="'Search for the selected companies\' services.'|pgettext('CreateBillingPlan')"
      >
        <UcCompanySelector
          name="companies"
          :item="item"
          path="companies"
          multiple
          clearable
        >
        </UcCompanySelector>
      </ItpFormGroup>
      <ItpFormGroup
        name="tenants"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
        :label="'Partners'|pgettext('CreateBillingPlan')"
        :helpTooltip="'Search for the selected partners\' services.'|pgettext('CreateBillingPlan')"
      >
        <UcCompanySelector
          name="tenants"
          :item="item"
          path="tenants"
          multiple
          clearable
        >
        </UcCompanySelector>
      </ItpFormGroup>
      <ItpFormGroup
        name="rentals"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
        :label="'Rentals'|pgettext('CreateBillingPlan')"
        :helpTooltip="'Search for the selected rentals\' services.'|pgettext('CreateBillingPlan')"
      >
        <UcCompanySelector
          name="rentals"
          :item="item"
          path="rentals"
          multiple
          clearable
        >
        </UcCompanySelector>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <AsyncCommand
      type="submit"
      size="sm"
      operation="create_billing_plan"
      :payload="() => getPayload(item)"
      variant="primary"
      :icon="$config.processIcon"
      :text="'Create billing plan'|pgettext('BillingList|Submit')"
      :form="forms[formName] && forms[formName].id"
      class="ml-2"
      @completed="evh_1548630417156826_completed($event, {})"
    >
    </AsyncCommand>
    <ItpButton
      :text="'Close'|pgettext('CreateBillingPlan')"
      variant="default"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class CreateBillingPlan extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_item = new ComponentValueCache(this, "item", "CreateBillingPlan.item");
  }

  getPayload(...args: any[]) {
    const [item] = args;
    const result = _.pick(item, [
      'day',
      'max_date'
    ])

    for (let field of [
      'contracts',
      'rentals',
      'companies',
      'tenants'
    ]) {
      if (_.isArray(item[field])) {
        result[field] = _.map(item[field], 'id');
      }
    }

    return result;
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formName!: any;
  labelAlign!: any;
  item!: any;

  async $$load_item() {
    return {
      day: this.$fn.today(),
      max_date: null,
      contracts: null,
      companies: null,
      rentals: null,
      tenants: null,
    }
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['formName', 'labelAlign', 'item', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formName: "CreateBillingPlanOptions",
        labelAlign: "right",
        item: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("CreateBillingPlan|Title", "Create Billing Plan"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2186_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2186, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1548630417156826_closeComponent_2190_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1548630417156826_closeComponent_2190, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data,
      }
      ,
    }
  }

  async evh_1548630417156826_completed(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_completed.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2186: actions.CloseModalAction;
    evh_7315092382398562_close_2185: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_2188: actions.CloseComponentAction;
    evh_2248226175642056_close_2187: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1548630417156826_closeComponent_2190: actions.CloseComponentAction;
    evh_1548630417156826_completed_2189: actions.EventHandlerImpl;
    evh_1548630417156826_completed: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_2192: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_2191: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2186 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2186_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2185 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2186,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2185],
      }
    );
    const act_2248226175642056_closeComponent_2188 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_2187 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_2188,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_2187],
      }
    );
    const act_1548630417156826_closeComponent_2190 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1548630417156826_closeComponent_2190_getActionArgs,
        events: [],
      }
    );
    const evh_1548630417156826_completed_2189 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_closeComponent_2190,
        event: "completed",
        displayName: "closeComponent",
      }
    );
    const evh_1548630417156826_completed = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_completed_2189],
      }
    );
    const act_1419464017721962_closeComponent_2192 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_2191 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_2192,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_2191],
      }
    );
    return {
      act_7315092382398562_closeModal_2186,
      evh_7315092382398562_close_2185,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_2188,
      evh_2248226175642056_close_2187,
      evh_2248226175642056_close,
      act_1548630417156826_closeComponent_2190,
      evh_1548630417156826_completed_2189,
      evh_1548630417156826_completed,
      act_1419464017721962_closeComponent_2192,
      evh_1419464017721962_clickPreventStop_2191,
      evh_1419464017721962_clickPreventStop,
    }
  }
}

Vue.component("CreateBillingPlan", CreateBillingPlan);

</script>